(function() { window.GUID_4c5f15a1_ba48_48f3_b025_077511938fb4 = { getGuid: function() { return "4c5f15a1-ba48-48f3-b025-077511938fb4"; } }; })();
var CS;
(function (CS) {
    class PullToRefresh {
        constructor() {
            let me = this;
            CS.PullToRefresh.Current = me;
            me.Disabled = true;
            me.$pullToRefreshInd = $("#pull-to-refresh");
            me.mindistance = 70;
            CS.Ajax.AjaxListener.OnAjaxStateChange((state) => {
                if (state == CS.Ajax.AjaxState.PageContentReplaced) {
                    me.TryStart();
                }
            });
            me.TryStart();
            CS.Controls.Popup.Events.PopupShow({
                selector: "body",
                childSelector: ".popup",
                extraEventNamespace: "pulltorefresh",
                callback: (popup, e) => {
                    me.TryStart(popup.$Control.find(".pulltorefresh-disabled").length > 0);
                },
            });
            CS.Controls.Popup.Events.PopupClose({
                selector: "body",
                childSelector: ".popup",
                callback: (popup, e) => {
                    me.TryStart(this.preventReactivationAfterPopup);
                },
            });
            CS.DOM.$body.trigger("pullToRefreshLoaded");
        }
        TryStart(forceDesactivate = false) {
            CS.Helper.log('PullToRefresh", "Starting...');
            if (forceDesactivate) {
                this.Desactivate();
            }
            else if ($(".section-middle").last().find(".pulltorefresh-disabled").length == 0) {
                if (this.Disabled) {
                    this.Start();
                }
            }
            else {
                this.Desactivate();
            }
        }
        Desactivate() {
            CS.Helper.log('PullToRefresh", "Desactivating...');
            CS.DOM.$doc.off("mousemove.pullrefresh touchmove.pullrefresh");
            CS.DOM.$doc.off("mouseup.pullrefresh touchend.pullrefresh");
            this.Disabled = true;
            CS.Helper.log('PullToRefresh", "Desactivated');
        }
        Start() {
            let me = this;
            me.Disabled = false;
            CS.DOM.$doc
                .offon("mousemove.pullrefresh touchmove.pullrefresh", this.handleMove.bind(this))
                .offon("mouseup.pullrefresh touchend.pullrefresh", this.handleEnd.bind(this));
        }
        hide() {
            this.startY = null;
            this.started = false;
            this.$pullToRefreshInd.css("height", 0);
            this.$pullToRefreshInd.removeClass("ready");
        }
        handleEnd(e) {
            if (this.$pullToRefreshInd.hasClass("ready")) {
                CS.Nav.Refresh();
            }
            this.hide();
        }
        static HandleMove(e) {
            try {
                const instance = CS.PullToRefresh.Current;
                if (!instance) {
                    return;
                }
                instance.handleMove(e);
            }
            catch (error) {
                console.error("Error while handling move", error);
            }
        }
        handleMove(e) {
            var _a;
            try {
                const touches = ((_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.touches) || e.touches;
                const currentY = touches ? touches[0].screenY : e.screenY;
                if (this.Disabled) {
                    return;
                }
                if ((e.buttons == 1 || touches != null) &&
                    (this.started || CS.DOM.$doc.scrollTop() == 0)) {
                    if (CS.DOM.$doc.scrollTop() > 10) {
                        this.hide();
                    }
                    else if (!this.startY) {
                        this.startY = currentY;
                        this.startTime = new Date();
                        this.started = true;
                    }
                    else if (this.startY) {
                        let diff = currentY - this.startY;
                        let diffTime = new Date().getTime() - this.startTime.getTime();
                        if (diffTime > 250) {
                            if (this.mindistance <= diff) {
                                this.$pullToRefreshInd.addClass("ready");
                            }
                            else {
                                this.$pullToRefreshInd.removeClass("ready");
                            }
                            this.$pullToRefreshInd.css("height", diff);
                        }
                    }
                }
                else {
                    this.hide();
                }
            }
            catch (error) {
                console.error("Error while handling move", error);
            }
        }
    }
    CS.PullToRefresh = PullToRefresh;
})(CS || (CS = {}));
window.addEventListener("load", () => {
    new CS.PullToRefresh();
});

//# sourceMappingURL=cs-pulltorefresh.js.map
